import React = require("react");
import { Library } from "..";
import menuLink from "../shared/menuLinkWithoutIcons";
import { primaryColor } from "../whitelabel";
import homeJumbo from "../whitelabel/homeJumbo";
import footerTop from "./footerTop";
import newsletterBlock from "./newsLetterForm";

const logo = () => <img width="231" height="83" src="/bkw/images/twente/logo.svg" alt="Bibliotheek Twente" aria-hidden="true" />
const collectionSearchUrl = (term: string) => `https://rijnbrink.hostedwise.nl/wise-apps/catalog/5403/search/iets/${term}`
const loginUrl = "https://rijnbrink.hostedwise.nl/wise-apps/opac/branch/5403/my-account"
const notFoundPath = '/404'

const searchPlaceholderImage = {
  src: '/bkw/images/twente/logo.svg',
  alt: 'Logo Bibliotheek Twente',
  width: "322",
  height: "125"
}

const twente: Library = {
  logo, homeJumbo, menuLink, footerTop, newsletterBlock, collectionSearchUrl, loginUrl, notFoundPath, searchPlaceholderImage, primaryColor,
  features: { autoHyphenate: false, manualHyphenate: true },
  copy: {
    forms: {
      loadingFailed: 'Het formulier kon helaas niet geladen worden. Herlaad de pagina of neem contact op met Bibliotheek Twente.'
    },
    vacancies: {
      noVacanciesFound:
        `Helaas, we zoeken op dit moment geen nieuwe collega’s. Houd de website in de gaten voor
        passende vacatures, we zijn regelmatig op zoek naar versterking voor onze bibliotheken!`
    }
  }
}
export default twente
